import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { loginRequest} from '../authConfig';
// import logo from 'assets/img/illustrations/recycle-24023_1280.png';
import logo from 'assets/img/illustrations/csvc.png';
// import classNames from 'classnames';

export const MsalLoginLinkPage = () => {
    const { instance } = useMsal();
/*
    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
    }

    const handleLoginPopup = (event) => {
        event.preventDefault()
        instance
            .loginPopup({
                ...loginRequest,
                redirectUri: '/redirect',
            })
            .catch((error) => console.log(error));
    };
*/
    const handleLoginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };
/*
    const handleLogoutRedirect = () => {
        instance.logoutRedirect();
    };

    const handleLogoutPopup = () => {
        instance.logoutPopup({
            mainWindowRedirectUri: '/csvc/home', // redirects the top level app after logout
        });
    };

    const handleProfileEdit = () => {
        if (inProgress === InteractionStatus.None) {
            instance.acquireTokenRedirect(b2cPolicies.authorities.editProfile);
        }
    };
*/
    /*
        return (
            <>
                <button onClick={handleLoginPopup}>
                    Sign in using Popup
                </button>
                <br /><br />
                <button onClick={handleLoginRedirect}>
                    Sign in using Redirect
                </button>
            </>
        );
 
    return (
        <>
            <button onClick={handleLoginRedirect}>
                Sign in using Redirect
            </button>
        </>
    )
   */
    return (
        <Container>
            <Row className="justify-content-md-center">
                <Col xs lg="2"></Col>
                <Col md="auto">&nbsp;</Col>
                <Col xs lg="2"></Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs lg="2"></Col>
                <Col md="auto">&nbsp;</Col>
                <Col xs lg="2"></Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs lg="2"></Col>
                <Col md="auto">&nbsp;</Col>
                <Col xs lg="2"></Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs lg="2"></Col>
                <Col md="auto"><img className="me-2 entrance-page-csvc-logo-img" src={logo} alt="Logo" width={256} />
                </Col>
                <Col xs lg="2"></Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs lg="2"></Col>
                <Col md="auto">&nbsp;</Col>
                <Col xs lg="2"></Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs lg="2"></Col>
                <Col md="auto"><Button variant='primary' className='me-2 mb-1' size="lg" onClick={handleLoginRedirect}>E N T R A</Button></Col>
                <Col xs lg="2"></Col>
            </Row>
        </Container>
    );
};




/*
    return (
        <>
            <Navbar bg="primary" variant="dark" className="navbarStyle">
                <a className="navbar-brand" href="/">
                    Microsoft identity platform
                </a>
                <AuthenticatedTemplate>
                    <Nav.Link className="navbarButton" href="/todolist">
                        Todolist
                    </Nav.Link>
                    <div className="collapse navbar-collapse justify-content-end">
                        <Button variant="info" onClick={handleProfileEdit} className="profileButton">
                            Edit Profile
                        </Button>

                        <DropdownButton
                            variant="warning"
                            drop="start"
                            title={activeAccount && activeAccount.username ? activeAccount.username : 'Unknown'}
                        >
                            <Dropdown.Item as="button" onClick={handleLogoutPopup}>
                                Sign out using Popup
                            </Dropdown.Item>
                            <Dropdown.Item as="button" onClick={handleLogoutRedirect}>
                                Sign out using Redirect
                            </Dropdown.Item>
                        </DropdownButton>
                    </div>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <div className="collapse navbar-collapse justify-content-end">
                        <DropdownButton variant="secondary" className="ml-auto" drop="start" title="Sign In">
                            <Dropdown.Item as="button" onClick={handleLoginPopup}>
                                Sign in using Popup
                            </Dropdown.Item>
                            <Dropdown.Item as="button" onClick={handleLoginRedirect}>
                                Sign in using Redirect
                            </Dropdown.Item>
                        </DropdownButton>
                    </div>
                </UnauthenticatedTemplate>
            </Navbar>
        </>
    );
    */